import { BiogenFunction } from 'modules/maya/basics/enums/maya.enums';

const biogenFunctionOptions = Object.values(BiogenFunction).map(
  (biogenFunction) => { return { id: biogenFunction, label: biogenFunction }; },
);

export default biogenFunctionOptions;
